import checkAccess from 'config/permissions/checkAccess';
import RolesOrganization from 'config/permissions/RolesOrganization';

export const PROCESSING_ACTIVITIES_ADMIN_ORGANIZATION_ROLES = [RolesOrganization.RopaAdministrator];

type UserDataWithRoles = {
  roles?: RolesOrganization[];
};

const canAccessProcessingActivitiesAdmin = (userData: UserDataWithRoles): boolean =>
  checkAccess(userData.roles ?? [], PROCESSING_ACTIVITIES_ADMIN_ORGANIZATION_ROLES);

export default canAccessProcessingActivitiesAdmin;
